import { NgModule } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { SidebarModule } from 'primeng/sidebar';
import { DynamicDialogModule, DialogService } from 'primeng/dynamicdialog';
import { InputTextModule } from 'primeng/inputtext';
import { DropdownModule } from 'primeng/dropdown';
import { InputNumberModule } from 'primeng/inputnumber';
import { DialogModule } from 'primeng/dialog';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ProgressSpinnerModule } from 'primeng/progressspinner';

import { TieredMenuModule } from 'primeng/tieredmenu';
import { MenuModule } from 'primeng/menu';
import { MenubarModule } from 'primeng/menubar';
import { PanelMenuModule } from 'primeng/panelmenu';
import { SlideMenuModule } from 'primeng/slidemenu';
import { TableModule } from 'primeng/table';
import { SelectButtonModule } from 'primeng/selectbutton';
import { TriStateCheckboxModule } from 'primeng/tristatecheckbox';
import { CheckboxModule } from 'primeng/checkbox';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { ContextMenuModule } from 'primeng/contextmenu';
import { SpeedDialModule } from 'primeng/speeddial';
import { ToastModule } from 'primeng/toast';
import { MessagesModule } from 'primeng/messages';
import { MessageModule } from 'primeng/message';
import { ChipModule } from 'primeng/chip';
import { BadgeModule } from 'primeng/badge';
import { PasswordModule } from 'primeng/password';
import { MultiSelectModule } from 'primeng/multiselect';
import { TooltipModule } from 'primeng/tooltip';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { AutoFocusModule } from 'primeng/autofocus';
import { InputSwitchModule } from 'primeng/inputswitch';
import { TreeSelectModule } from 'primeng/treeselect';
import { ChipsModule } from 'primeng/chips';
import { TabViewModule } from 'primeng/tabview';
import { EditorModule } from 'primeng/editor';
import { BlockUIModule } from 'primeng/blockui';
import { CalendarModule } from 'primeng/calendar';
import { StepsModule } from 'primeng/steps';
import { RadioButtonModule } from 'primeng/radiobutton';
import { SplitButtonModule } from 'primeng/splitbutton';
import { FormsModule } from '@angular/forms';
import { AccordionModule } from 'primeng/accordion';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { ProgressBarModule } from 'primeng/progressbar';
import { PaginatorModule } from 'primeng/paginator';
import { DataViewModule, DataViewLayoutOptions } from 'primeng/dataview';
import { ListboxModule } from 'primeng/listbox';
import { CardModule } from 'primeng/card';
import { InputMask, InputMaskModule } from 'primeng/inputmask';
import { FileUploadModule } from 'primeng/fileupload';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { ToggleButtonModule } from 'primeng/togglebutton';
import { SkeletonModule } from 'primeng/skeleton';

const m = [
  FormsModule,
  CardModule,
  ButtonModule,
  SidebarModule,
  DynamicDialogModule,
  DialogModule,
  ProgressSpinnerModule,
  ConfirmDialogModule,
  InputTextModule,
  DropdownModule,
  InputNumberModule,
  TieredMenuModule,
  MenuModule,
  MenubarModule,
  PanelMenuModule,
  SlideMenuModule,
  TableModule,
  SelectButtonModule,
  TriStateCheckboxModule,
  CheckboxModule,
  BreadcrumbModule,
  ContextMenuModule,
  SpeedDialModule,
  ToastModule,
  MessageModule,
  MessagesModule,
  ChipModule,
  BadgeModule,
  PasswordModule,
  MultiSelectModule,
  TreeSelectModule,
  ChipsModule,
  TabViewModule,
  EditorModule,
  BlockUIModule,
  CalendarModule,
  TooltipModule,
  InputTextareaModule,
  AutoFocusModule,
  InputSwitchModule,
  StepsModule,
  RadioButtonModule,
  SplitButtonModule,
  AccordionModule,
  AutoCompleteModule,
  ProgressBarModule,
  PaginatorModule,
  DataViewModule,
  ListboxModule,
  FileUploadModule,
  InputMaskModule,
  OverlayPanelModule,
  ToggleButtonModule,
  SkeletonModule,
];

@NgModule({
  declarations: [],
  imports: m,
  providers: [DialogService],
  exports: m,
})
export class PrimeModule {}
